import AxiosConfig from '../config/axios-config'

export default {

  obterEstatisticasHome () {
    return AxiosConfig.secureJalekoAPI().get('/resumo').then(response => response.data)
  }

}
